import { useCallback, useRef, useState } from 'react';
import { useUnmount } from 'react-use';
import { SetTimeoutResult } from 'src/utils/UtilityTypes';

export default function useDesktopNavDropdown() {
	const [open, setOpen] = useState(false);

	const closeTimeoutRef = useRef<SetTimeoutResult>(null);
	const openTimeoutRef = useRef<SetTimeoutResult>(null);

	const handleMouseEnter = useCallback(() => {
		if (closeTimeoutRef.current) {
			clearTimeout(closeTimeoutRef.current);
		}

		openTimeoutRef.current = setTimeout(() => {
			setOpen(true);
		}, 100);
	}, []);

	const handleMouseLeave = useCallback(() => {
		if (openTimeoutRef.current) {
			clearTimeout(openTimeoutRef.current);
		}

		closeTimeoutRef.current = setTimeout(() => {
			setOpen(false);
		}, 100);
	}, []);

	// Prevents autofocusing the trigger on close. Without this, if the user moves
	// directly from one dropdown to another, the autofocus will cause it to close.
	const handleCloseAutofocus = useCallback((e: Event) => {
		e.preventDefault();
	}, []);

	useUnmount(() => {
		if (closeTimeoutRef.current) {
			clearTimeout(closeTimeoutRef.current);
		}

		if (openTimeoutRef.current) {
			clearTimeout(openTimeoutRef.current);
		}
	});

	return {
		open,
		setOpen,
		handleMouseEnter,
		handleMouseLeave,
		handleCloseAutofocus,
	};
}
